import axios from "axios";

const fetch = () => axios.get("/api/v1/neeto_apps");

const neetoAppsApi = { fetch };

export default neetoAppsApi;
